var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// @flow
// @ts-nocheck
import React, { Component } from 'react';
// utils
import { toJS } from '@shared/utils/immutable';
import { connect } from 'react-redux';
// action
import { getCollection } from '@store/collection/actions';
// selectors
import { selectItem as selectCollection, selectLoading as selectLoadingCollection, selectShouldLoadItem as selectShouldLoadCollection, } from '@store/collection/selectors';
// components
import Session from 'containers/Session';
import Page from 'pages/Collection';
var Collection = /** @class */ (function (_super) {
    __extends(Collection, _super);
    function Collection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Collection.prototype.componentDidMount = function () {
        if (this.props.shouldLoadCollection) {
            this.props.getCollection(this.props.match.params.id);
        }
    };
    Collection.prototype.render = function () {
        var _a = this.props, collection = _a.collection, collectionLoading = _a.collectionLoading;
        return (_jsx(Session, { children: function (sessionProps) { return (_jsx(Page, __assign({}, sessionProps, { collectionLoading: collectionLoading, collection: collection }), void 0)); } }, void 0));
    };
    return Collection;
}(Component));
var select = function () { return function (state, props) { return ({
    collection: selectCollection()(state, parseInt(props.match.params.id, 10)),
    collectionLoading: selectLoadingCollection(state),
    shouldLoadCollection: selectShouldLoadCollection()(state, parseInt(props.match.params.id, 10)),
}); }; };
export var Container = Collection;
export default connect(select, {
    getCollection: getCollection,
})(toJS(Container));
